<template>
  <fill-vertical-layout headerBg="headerColor">
    <template v-slot:header-row-1-left>
      <div class="d-flex full-width" v-if="labels && labels.length > 0">
        <div class="pa-2" v-ripple :class="{ 'font-weight-bold': !selectedLabel }" @click="selectLabel(null)">alle</div>
        <div
          v-for="(label, ind) in labels"
          :key="ind"
          class="pa-2"
          v-ripple
          :class="{ 'font-weight-bold': selectedLabel && selectedLabel.id === label.id }"
          @click="selectLabel(label)"
        >
          {{ label.label }}
        </div>
      </div>
      <rounded-button
        v-for="(category, ind) in sortedCategories"
        :key="ind"
        flexColumn
        style="margin-right: 15px"
        :isSelected="selectedCategories && category && selectedCategories.filter((c) => c.id === category.id).length > 0"
        @click="selectCategory(category)"
        :label="getCategoryName(category)"
        :showBadge="unreadCountsByType[category.id] > 0"
        :badgeColor="theme.unreadBadgeColor"
        :offsetX="8"
        :offsetY="-8"
        :count="unreadCountsByType[category.id]"
      >
      </rounded-button>
    </template>
    <template v-slot:header-row-1-right>
      <v-menu v-if="showFilter" :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon v-if="docsFilterIsActive">mdi-filter-check-outline</v-icon>
            <v-icon v-else>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <v-list class="pt-0">
          <v-list-item v-if="showFilterIgnore">
            <v-list-item-title v-if="isTourRoute">{{ $t('fahrdienst452.filterIgnoreCourse') }}</v-list-item-title>
            <v-list-item-title v-else>{{ $t('fahrdienst452.filterIgnoreUmlauf') }}</v-list-item-title>
            <v-list-item-action>
              <v-switch v-model="docsFilter.ignoreCourse" @change="updateIgnoreCourse"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="showFilterIgnore"></v-divider>
          <v-list-item v-if="showFilterIgnore && labels && labels.length > 0">
            <v-list-item-title>{{ $t('fahrdienst452.filterIgnoreLabels') }}</v-list-item-title>
            <v-list-item-action>
              <v-switch v-model="docsFilter.ignoreLabels" @change="updateIgnoreLabels"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="showFilterIgnore && labels && labels.length > 0"></v-divider>
          <v-list-item v-if="showFilterIgnore && categories && categories.length > 1">
            <v-list-item-title>{{ $t('fahrdienst452.filterIgnoreType') }}</v-list-item-title>
            <v-list-item-action>
              <v-switch v-model="docsFilter.ignoreType" @change="updateIgnoreCategories"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="showFilterIgnore && categories && categories.length > 1"></v-divider>
          <v-list-item v-if="showFilterIgnore">
            <v-list-item-title>{{ $t('fahrdienst452.filterIgnoreDate') }}</v-list-item-title>
            <v-list-item-action>
              <v-switch v-model="docsFilter.ignoreDate" @change="updateIgnoreDate"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="showFilterIgnore"></v-divider>
          <v-spacer v-if="showFilterIgnore" class="my-6"></v-spacer>
          <v-divider v-if="showFilterIgnore"></v-divider>
          <v-list-item>
            <v-list-item-title>{{ $t('fahrdienst452.filterOnlyUnread') }}</v-list-item-title>
            <v-list-item-action>
              <v-switch v-model="docsFilter.unreadOnly"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <template v-if="showFilterUnconfirmedOnly">
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-title>{{ $t('fahrdienst452.filterOnlyUnconfirmed') }}</v-list-item-title>
              <v-list-item-action>
                <v-switch v-model="docsFilter.unconfirmedOnly"></v-switch>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-divider></v-divider>
          <v-list-item v-if="relevanceIsEnabled">
            <v-list-item-title>{{ $t('fahrdienst452.filterOnlyRelevant') }}</v-list-item-title>
            <v-list-item-action>
              <v-switch v-model="docsFilter.relevantOnly"></v-switch>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="relevanceIsEnabled"></v-divider>
          <v-list-item class="px-2">
            <v-btn color="error" class="mt-2 mx-0" block @click="openSetAsReadDialog = true">{{ $t('fahrdienst452.filterSetAllToRead') }}</v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
      <sort-menu v-if="showSorting" class="justify-end" v-model="sorterName" :smallIcon="false"></sort-menu>
      <v-dialog v-model="openSetAsReadDialog" max-width="600px">
        <v-card>
          <v-card-title class="text-center">{{ $t('fahrdienst452.filterSetAllToReadConfirm') }}</v-card-title>
          <v-card-subtitle class="text-center pt-1" v-if="relevanceIsEnabled">{{ $t('fahrdienst452.filterExcludeRelevant') }}</v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" @click="openSetAsReadDialog = false">{{ $t('fahrdienst452.filterButtonCancel') }}</v-btn>
            <v-btn color="error" @click="markFullyFilteredDocumentsAsRead">{{ $t('fahrdienst452.filterButtonOk') }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-slot:content>
      <fahrdienst-doc-list
        :documents="fullyFilteredDocuments"
        :selectedDocument="selectedDocument"
        :sorterName="sorterName"
        @toggleFavoriteState="(doc) => $emit('toggleFavorite', doc)"
        @onSelected="(doc) => $emit('docSelected', doc)"
        :updateRequired="updateRequired"
        :markAsReadOnSelect="false"
      ></fahrdienst-doc-list>
    </template>
  </fill-vertical-layout>
</template>

<script>
import FahrdienstDocList from './FahrdienstDocList';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import readService from '@/services/readService';
import acknowledgeService from '@/services/acknowledgeService';
import mandatoryToReadService from '@/services/mandatoryToReadService';
import dateUtils from '@/common/dateUtils';
import RoundedButton from '@/components/buttons/RoundedButton';
import SortMenu from '@/components/menus/SortMenu';
import { LOCAL_STORAGE_DOCUMENT_SORTER_NAME } from '@/common/constants';
import FillVerticalLayout from '@/components/container/FillVerticalLayout';
import fahrdienst452Mixin from '@/modules/fahrdienst452/fahrdienst452Mixin';
import uiHelpers from '@/common/uiHelpers';

import {
  ROUTE_FAHRDIENST,
  ROUTE_FAHRDIENST_FILE,
  ROUTE_FAHRDIENST_TOUR_FILE,
  ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK,
  ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK_FILE,
  ROUTE_FAHRDIENST_TOUR_DATE,
  ROUTE_FAHRDIENST_TOUR_DATE_FILE,
  ROUTE_FAHRDIENST_TOUR_LINE_TRACK,
  ROUTE_FAHRDIENST_TOUR_LINE_TRACK_FILE,
  ROUTE_FAHRDIENST_HASH_FILE,
  ROUTE_FAHRDIENST_HASH_DATE_TOUR,
  ROUTE_FAHRDIENST_HASH_DATE_TOUR_FILE,
  ROUTE_FAHRDIENST_HASH_DATE,
  ROUTE_FAHRDIENST_HASH_DATE_FILE,
  ROUTE_FAHRDIENST_HASH_TOUR,
  ROUTE_FAHRDIENST_HASH_TOUR_FILE,
} from '@/modules/fahrdienst452/routes';

const ROOT = { root: true };

export default {
  mixins: [common, configMixin, fahrdienst452Mixin],
  components: {
    FahrdienstDocList,
    FillVerticalLayout,
    RoundedButton,
    SortMenu,
  },
  props: {
    value: { type: Boolean, default: false }, //v-model, that is true to display related docs only
    categories: { type: Array, default: () => [] },
    selectedDocument: Object,
    // all documents that can be displayed. Will be separated by type (property in document item named according property categoryPropertyName)
    filteredDocuments: { type: Array, default: () => [] },
    labels: Array, // labels for label filtering on filteredDocuments ._labelIds
    filteredDisplayText: String,
    categoryPropertyName: String,
    showFooter: { type: Boolean, default: true },
    showFilter: { type: Boolean, default: true },
    showSorting: { type: Boolean, default: true },
    totalUnreadCount: Number,
    updateRequired: Boolean,
    storeLabelSelection: { type: Boolean, default: false },
    storeCategorySelection: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedLabel: null,
      selectedCategories: this.categories ? [this.categories[0]] : [],
      multiCategorySelectEnabled: false,
      documentType: this.documentSelectionType,
      relatedDocsOnly: this.value,
      sorterName: localStorage.getItem(LOCAL_STORAGE_DOCUMENT_SORTER_NAME) || 'byImportance',
      docsFilter: {
        ignoreCourse: !this.value,
        ignoreLabels: false,
        ignoreType: false,
        ignoreDate: false,
        unreadOnly: false,
        unconfirmedOnly: false,
        relevantOnly: false,
      },
      openSetAsReadDialog: false,
    };
  },
  mounted() {
    const storedDocsFilter = localStorage.getItem('fahrdienst452DocsFilter');
    if (storedDocsFilter) {
      this.docsFilter = JSON.parse(storedDocsFilter);
    }

    if (this.routeName === ROUTE_FAHRDIENST_FILE) {
      this.selectedLabel = null;
      this.selectedCategories = [];
    } else {
      if (this.storeLabelSelection) {
        const storedLabels = localStorage.getItem('fahrdienst452SelectedLabel');
        if (storedLabels) {
          this.selectedLabel = JSON.parse(storedLabels);
        }
      }

      if (this.storeCategorySelection) {
        const storedCategories = localStorage.getItem('fahrdienst452SelectedCategories');
        if (storedCategories) {
          this.selectedCategories = JSON.parse(storedCategories);
        }
      }
    }

    if (this.line || this.track || this.tourHash) {
      this.docsFilter.ignoreCourse = false;
    } else {
      this.docsFilter.ignoreCourse = true;
    }
    if (this.selectedLabel) {
      if (this.docsFilter.ignoreLabels) {
        this.docsFilter.ignoreLabels = false;
      }
    } else {
      if (!this.docsFilter.ignoreLabels) {
        this.docsFilter.ignoreLabels = true;
      }
    }
    if (this.selectedCategories && Array.isArray(this.selectedCategories) && this.selectedCategories.length > 0) {
      if (this.docsFilter.ignoreType) {
        this.docsFilter.ignoreType = false;
      }
    }
    if (this.dateYYYYMMDD) {
      this.docsFilter.ignoreDate = false;
    } else {
      this.docsFilter.ignoreDate = true;
    }
    this.$emit('docsFilterUpdated', this.docsFilter);
  },
  computed: {
    moduleConfig() {
      return this.getModuleConfig('Fahrdienst452');
    },
    relevanceIsEnabled() {
      return this.moduleConfig && this.moduleConfig.relevanceEnabled;
    },
    showFilterUnconfirmedOnly() {
      return this.moduleConfig && !this.moduleConfig.hideFilterUnconfirmedOnly;
    },
    docsFilterIsActive() {
      if (this.showFilterIgnore) {
        return (
          this.docsFilter.ignoreCourse ||
          this.docsFilter.ignoreLabels ||
          this.docsFilter.ignoreType ||
          this.docsFilter.ignoreDate ||
          this.docsFilter.unreadOnly ||
          this.docsFilter.unconfirmedOnly ||
          this.docsFilter.relevantOnly
        );
      } else {
        return this.docsFilter.unreadOnly || this.docsFilter.unconfirmedOnly || this.docsFilter.relevantOnly;
      }
    },
    unreadCountsByType() {
      return this.calculateUnreadCountsByType();
    },
    fullyFilteredDocuments() {
      let labelFilteredDocs = this.docsFilter.ignoreLabels ? this.filteredDocuments : this.filterByLabels(this.filteredDocuments, this.selectedLabel);
      let categoryFilteredDocs = this.docsFilter.ignoreType ? labelFilteredDocs : this.filterByCategories(labelFilteredDocs, this.selectedCategories);
      let relvanceFilteredDocs = this.docsFilter.relevantOnly ? this.filterByRelevance(categoryFilteredDocs) : categoryFilteredDocs;
      let unreadFilteredDocs = this.docsFilter.unreadOnly ? this.filterByUnread(relvanceFilteredDocs) : relvanceFilteredDocs;
      let unconfirmedFilteredDocs = this.docsFilter.unconfirmedOnly ? this.filterByUnconfirmed(unreadFilteredDocs) : unreadFilteredDocs;
      return unconfirmedFilteredDocs;
    },
    labelFilteredDocuments() {
      if (!this.selectedLabel) return this.filteredDocuments;
      return this.filteredDocuments.filter((doc) => {
        if (!doc._labelIds) {
          doc._labelIds = [];
        }
        return doc._labelIds.includes(this.selectedLabel.id);
      });
    },
    sortedCategories() {
      return this.categories.slice().sort((a, b) => (a.sort > b.sort ? 1 : -1));
    },
    documentsByType() {
      const documentsByType = {};
      this.categories.forEach((c) => {
        documentsByType[c.id] = this.labelFilteredDocuments.filter((d) => d.typeIdFk === c.id);
      });
      return documentsByType;
    },
    dateIsoString() {
      if (this.dateYYYYMMDD) {
        return dateUtils.reformatYYYYMMDDAsDateIsoString(this.dateYYYYMMDD);
      }
      return null;
    },
    showFilterIgnore() {
      return this.isTourRoute || this.isHashRoute;
    },
  },
  methods: {
    updateIgnoreCourse() {
      if (this.docsFilter.ignoreCourse) {
        let { dateYYYYMMDD, documentId } = this.$route.params;
        if (this.isTourRoute) {
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK) {
            this.$router.push({ name: ROUTE_FAHRDIENST_TOUR_DATE, params: { dateYYYYMMDD } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_TOUR_DATE_FILE, params: { dateYYYYMMDD, documentId } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_LINE_TRACK) {
            this.$router.push({ name: ROUTE_FAHRDIENST });
          }
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_LINE_TRACK_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_TOUR_FILE, params: { documentId } });
          }
        }
        if (this.isHashRoute) {
          if (this.routeName === ROUTE_FAHRDIENST_HASH_DATE_TOUR) {
            this.$router.push({ name: ROUTE_FAHRDIENST_HASH_DATE, params: { dateYYYYMMDD } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_HASH_DATE_TOUR_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_HASH_DATE_FILE, params: { dateYYYYMMDD, documentId } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_HASH_TOUR) {
            this.$router.push({ name: ROUTE_FAHRDIENST });
          }
          if (this.routeName === ROUTE_FAHRDIENST_HASH_TOUR_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_HASH_FILE, params: { documentId } });
          }
        }
      }
    },
    updateIgnoreLabels() {
      if (this.docsFilter.ignoreLabels) {
        this.selectedLabel = null;
      }
    },
    updateIgnoreCategories() {
      if (this.docsFilter.ignoreType) {
        this.selectedCategories = [];
      }
    },
    updateIgnoreDate() {
      if (this.docsFilter.ignoreDate) {
        let { tourHash, line, track, documentId } = this.$route.params;
        if (this.isTourRoute) {
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK) {
            this.$router.push({ name: ROUTE_FAHRDIENST_TOUR_LINE_TRACK, params: { line, track } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_TOUR_LINE_TRACK_FILE, params: { line, track, documentId } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_DATE) {
            this.$router.push({ name: ROUTE_FAHRDIENST });
          }
          if (this.routeName === ROUTE_FAHRDIENST_TOUR_DATE_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_TOUR_FILE, params: { documentId } });
          }
        }
        if (this.isHashRoute) {
          if (this.routeName === ROUTE_FAHRDIENST_HASH_DATE_TOUR) {
            this.$router.push({ name: ROUTE_FAHRDIENST_HASH_TOUR, params: { tourHash } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_HASH_DATE_TOUR_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_HASH_TOUR_FILE, params: { tourHash, documentId } });
          }
          if (this.routeName === ROUTE_FAHRDIENST_HASH_DATE) {
            this.$router.push({ name: ROUTE_FAHRDIENST });
          }
          if (this.routeName === ROUTE_FAHRDIENST_HASH_DATE_FILE) {
            this.$router.push({ name: ROUTE_FAHRDIENST_HASH_FILE, params: { documentId } });
          }
        }
      }
    },
    filterByLabels(documents, selectedLabel) {
      if (!selectedLabel) return documents;
      return documents.filter((doc) => {
        return doc._labelIds.includes(selectedLabel.id);
      });
    },
    filterByCategories(documents, selectedCategories) {
      //console.debug(`filterByCategories`, JSON.stringify(selectedCategories, null, 2));
      if (selectedCategories && selectedCategories.length === 0) return documents;
      return documents.filter((d) => {
        let finding = selectedCategories.find((c) => c.id === d.typeIdFk);
        if (finding) return true;
        return false;
      });
    },
    filterByRelevance(documents) {
      console.debug('filterByRelevance');
      return documents.filter((d) => {
        return d.isRelevant && d.isRelevant == 1;
      });
    },
    filterByUnread(documents) {
      console.debug('filterByUnread');
      return documents.filter((d) => {
        return readService.isUnread(d);
      });
    },
    filterByUnconfirmed(documents) {
      console.debug('filterByUnconfirmed');
      return documents.filter((d) => {
        return acknowledgeService.isToAcknowledge(d);
      });
    },
    getCategoryName(category) {
      return category.name;
    },
    selectLabel(label) {
      if (!label) {
        this.selectedLabel = null;
      } else if (this.selectedLabel && this.selectedLabel.id === label.id) {
        // toggle label selection
        this.selectedLabel = null;
      } else {
        this.selectedLabel = label;
      }
    },
    selectCategory(category) {
      if (!category) {
        this.selectedCategories = [];
      }

      if (this.selectedCategories && category && this.selectedCategories.find((c) => c.id === category.id)) {
        // toggle category selection
        if (this.multiCategorySelectEnabled) {
          this.selectedCategories = this.selectedCategories.filter((c) => c.id !== category.id);
        } else {
          this.selectedCategories = [];
        }
      } else {
        if (this.multiCategorySelectEnabled) {
          this.selectedCategories.push(category);
        } else {
          this.selectedCategories = [category];
        }
      }
    },
    calculateUnreadCountsByType() {
      let countsByType = {};
      if (this.categories && this.documentsByType) {
        this.categories.forEach((c) => {
          if (this.documentsByType[c.id]) {
            countsByType[c.id] = this.documentsByType[c.id].filter(
              (d) => mandatoryToReadService.isMandatoryToReadAndNotRead(d) || acknowledgeService.isToAcknowledge(d) || (readService.isUnread(d) && d.isRelevant)
            ).length;
          }
        });
      }
      return countsByType;
    },
    async markFullyFilteredDocumentsAsRead() {
      for (const d of this.fullyFilteredDocuments) {
        if (this.relevanceIsEnabled) {
          if (readService.isUnread(d) && !d.isRelevant) {
            await this.markAsRead(d);
          }
        } else {
          if (readService.isUnread(d)) {
            await this.markAsRead(d);
          }
        }
      }
      this.openSetAsReadDialog = false;
    },
    async markAsRead(document) {
      let sendboxTitle = this.$t('action.read.msg', { title: document.title });
      let snackbarText = this.$t('action.document.read');
      await this.$store.dispatch(
        `sendbox/markAsRead2`,
        {
          item: document,
          sendboxTitle,
          snackbarText,
          immediate: true,
        },
        ROOT
      );
    },
  },
  watch: {
    relatedDocsOnly(newValue, oldValue) {
      this.$emit('input', newValue);
    },
    sorterName(newValue) {
      localStorage.setItem(LOCAL_STORAGE_DOCUMENT_SORTER_NAME, newValue);
    },
    selectedLabel(newValue) {
      console.debug('selectedLabel', newValue);
      if (newValue) {
        if (this.docsFilter.ignoreLabels) {
          this.docsFilter.ignoreLabels = false;
        }
      }
      if (this.routeName !== ROUTE_FAHRDIENST_FILE) {
        localStorage.setItem('fahrdienst452SelectedLabel', JSON.stringify(newValue));
      }
    },
    selectedCategories(newValue) {
      console.debug('selectedCategories', newValue);
      if (newValue && Array.isArray(newValue) && newValue.length > 0) {
        if (this.docsFilter.ignoreType) {
          this.docsFilter.ignoreType = false;
        }
      }
      if (this.routeName !== ROUTE_FAHRDIENST_FILE) {
        localStorage.setItem('fahrdienst452SelectedCategories', JSON.stringify(newValue));
      }
    },
    docsFilter: {
      handler: function (newValue) {
        localStorage.setItem('fahrdienst452DocsFilter', JSON.stringify(newValue));
        this.$emit('docsFilterUpdated', newValue);
      },
      deep: true,
    },
    line(newValue, oldValue) {
      console.debug(`line changed from ${oldValue} to ${newValue}`);
      if (newValue) {
        if (this.docsFilter.ignoreCourse) {
          this.docsFilter.ignoreCourse = false;
          this.$emit('docsFilterUpdated', newValue);
        }
      }
    },
    track(newValue, oldValue) {
      console.debug(`track changed from ${oldValue} to ${newValue}`);
      if (newValue) {
        if (this.docsFilter.ignoreCourse) {
          this.docsFilter.ignoreCourse = false;
          this.$emit('docsFilterUpdated', newValue);
        }
      }
    },
    tourHash(newValue, oldValue) {
      console.debug(`tourHash changed from ${oldValue} to ${newValue}`);
      if (newValue) {
        if (this.docsFilter.ignoreCourse) {
          this.docsFilter.ignoreCourse = false;
          this.$emit('docsFilterUpdated', newValue);
        }
      }
    },
    dateYYYYMMDD(newValue, oldValue) {
      console.debug(`dateYYYYMMDD changed from ${oldValue} to ${newValue}`);
      if (newValue) {
        if (this.docsFilter.ignoreDate) {
          this.docsFilter.ignoreDate = false;
          this.$emit('docsFilterUpdated', newValue);
        }
      }
    },
  },
};
</script>

<style type="text/css">
.header-right-slot {
  width: 70px !important;
}
</style>
